import React, { useEffect, useState } from 'react';

import { Button, Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => {
  return {
    chkBoxSvg: {
      '& path': {
        outline: '3px solid rgba(0, 0, 0, 0.54)',
      },
    },
    countContainer: {
      alignItems: 'center',
      background: ' #F5F5F5',
      borderRadius: '10px',
      display: 'flex',
      height: '39px',
      justifyContent: 'center',
      width: '166px',
    },
    countText: {
      color: '#388E3C',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
    },
    patient: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
    },
    studyDescription: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
    },
    title: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      textAlign: 'left',
    },
    visitDate: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
    },
  };
});
export default ({ studies, planCount, onContinue }) => {
  const [checkedStudies, setcheckedStudies] = useState([]);
  const [userStudies, setUserStudies] = useState(studies);
  useEffect(() => {
    setUserStudies(
      studies.map((study) => {
        study.checked = study.mustBeSelected;
        return study;
      })
    );
  }, [studies]);

  useEffect(() => {
    setcheckedStudies(userStudies.filter((study) => study.checked));
  }, [userStudies]);
  const onStudyChecked = (checked, study) => {
    if (checked) {
      const studyIndex = userStudies.findIndex((item) => item === study);
      userStudies[studyIndex].checked = true;
      setUserStudies([...userStudies]);
      checkedStudies.push(userStudies[studyIndex]);
      setcheckedStudies([...checkedStudies]);
    } else {
      const studyIndex = userStudies.findIndex((item) => item === study);
      userStudies[studyIndex].checked = false;
      setUserStudies([...userStudies]);
      setcheckedStudies(checkedStudies.filter((item) => item.id !== study.id));
    }
  };
  const classes = useStyles();
  return (
    <>
      <Grid item container style={{ maxHeight: '250px', overflow: 'auto' }}>
        <Grid item container xs={12}>
          <Grid item xs={1}>
            <Typography className={classes.title}>Keep</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.title}>Patient</Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography className={classes.title}>Description</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.title}>Visit Date</Typography>
          </Grid>
        </Grid>
        {userStudies.map((study) => {
          return (
            <Grid item container xs={12} alignItems="center" style={{ marginTop: '0.5rem', textAlign: 'left' }}>
              <Grid item xs={1} style={{ textAlign: 'left' }}>
                <Checkbox
                  checked={study.mustBeSelected || study.checked}
                  disabled={study.mustBeSelected}
                  onChange={(event) => onStudyChecked(event.target.checked, study)}
                  style={{ padding: 0 }}
                  color="primary"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography className={classes.patient}>{study.patientName}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography className={classes.studyDescription}>{study.description}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography className={classes.visitDate}>{moment(study.visitDate).format('MM/DD/YYYY')}</Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid item container xs={12} justify="space-between" className="mt-2">
        <div className={classes.countContainer}>
          <Typography
            style={{ color: checkedStudies.length <= planCount ? '#388E3C' : '#B12A2A' }}
            className={classes.countText}>{`${checkedStudies.length}/${planCount} Selected`}</Typography>
        </div>
        <Button onClick={() => onContinue(checkedStudies)} disabled={checkedStudies.length > planCount} variant="contained" color="primary" style={{ width: '170px' }}>
          Continue
        </Button>
      </Grid>
    </>
  );
};
